import React, {useState} from "react";

import {useParams} from "react-router";
import {useQuery} from "react-query";

import {getIndicatorByCode} from "services/Indicators.service";
import {EditableTranslate} from "components/Table/editableTranslate";
import Loading from "components/Loading";

const FormTableTranslate = () => {

    const { code } = useParams();
    const [tables, setTables] = useState([])
    const [status, setStatus] = useState('')

    const {isFetching} = useQuery(["tables_indicator", code],
        () => {
            return getIndicatorByCode(code, 'en-US')
        }, {
            onSuccess: (response) => {
                setTables(response.data[0]?.tables)
            },
            onError: () => {
              //  toast.error(i18n.t('error.badRequest'));
            },
            retry: false,
            refetchOnWindowFocus: false
        }
    )

    if(isFetching) {
       return <Loading />
    }

    return (
        <div className="accordion" id="accordionExample">
            { tables?.map((item, index) =>
                <div className="accordion-item mb-0" key={index}>
                    <h2 className="accordion-header" id={`heading-table-${index}`}>
                        <button className="accordion-button collapsed" type="button" data-bs-toggle="collapse"
                                data-bs-target={`#table-${index}`} aria-expanded="false" aria-controls={`table-${index}`}>
                            #{index} - <b className="ps-1">{ item.titulo }</b>
                        </button>
                    </h2>
                    <div id={`table-${index}`} className="accordion-collapse collapse" aria-labelledby={`heading-table-${index}`}
                         data-bs-parent="#accordionExample">
                        <div className="accordion-body p-0">

                            <EditableTranslate table={item} />

                        </div>
                    </div>
                </div>
            )}
        </div>
    )
}

export default FormTableTranslate
